import cloneDeep from 'lodash/cloneDeep';
import Proxy from '@/proxies/SubstoreProductDetailsProxy';

export default (response, context) => {
  // disable next button (will be enabled after successful complete device selection)
  context.isNextDisabled = true;

  let selection = null;

  // package
  context.packageHook = () => import('@/components/Substore/Partners/ace/DeviceSelection');

  context.packageListeners.result = result => {
    selection = result;
    context.isNextDisabled = !result;
    context.$set(context.priceBindings, 'tariff', result?.tariff);
  };

  // price
  context.priceBindings.product = cloneDeep(context.product); // this.product will be overritten after selection, so we have to store the original by clone

  context.priceListeners.override = context.overrideWithProductGroup;

  context.priceHook = () => import('@/components/Substore/Partners/ace/PriceWrapper');

  const productGroupAction = cb => {
    /* we just override the cb, so overrideWithProductGroup is not called, but only productGroup is enabled */
    context.isProductGroup = true;
  };

  // submit button
  const nextAction = async cb => {
    const genericPartnerData = [
      { key: 'Partner.manufacturerName', value: selection.vendor },
      { key: 'Partner.modelName', value: selection.device.name },
      { key: 'Partner.deviceID', value: selection.device.id },
      { key: 'Partner.deviceClassId', value: selection.device.classId },
      { key: 'Partner.tariffId', value: selection.tariff.id },
      { key: 'Partner.insuranceClassId', value: selection.tariff.insurance.id },
      { key: 'Partner.paymentInterval', value: 'monatlich' },
    ];
    const params = { genericPartnerData, subscriptionTemplateId: selection.tariff.id };
    await new Proxy().partnerAction(params);
    cb();
  };

  return {
    productGroupAction,
    nextAction,
  };
};
